import {
  ObjectMap,
} from './interfaces'
import {
  cleanValidatorPayload,
  deepmerge, logger,
} from '../utils'
import { PayloadType } from '../utils/dataTypes'

class PsmEventQueue {
  static queuedEvents: Omit<PayloadType, "sentAtTimestamp">[] = []

  constructor() {
  }

  static updateQueue = function(payload: Partial<PayloadType>): void {
    if (Object.keys(payload).length > 0) {
      let deepClonedObject = deepmerge({}, payload) as Omit<PayloadType, "sentAtTimestamp">
      const eventCleanedAndValidated = cleanValidatorPayload(deepClonedObject)
      PsmEventQueue.queuedEvents.push(eventCleanedAndValidated)
      logger('QueuedEvents cleaned and validated --->', PsmEventQueue.queuedEvents)
    }
  }

  static retrieveQueue = function(): ObjectMap {
    const queueResults = deepmerge([], PsmEventQueue.queuedEvents)
    PsmEventQueue.queuedEvents = []
    return queueResults
  }
}

export default PsmEventQueue
